import { collapseDepartureGroup } from "../configurazione/adapters";

// `ricerca` is the canonical applied selection of the orders tables. Search
// drafts (quick bar, advanced popup) start from it; transports derive from it.

function leggiMongoFilters(value) {
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
}

export function normalizzaMongoFilters(value) {
  const source = leggiMongoFilters(value);
  if (!source || typeof source !== "object" || Array.isArray(source)) return {};
  return Object.entries(source).reduce((acc, [k, v]) => {
    if (Array.isArray(v)) {
      const cleaned = v.filter(
        (item) => item !== "" && item !== null && item !== undefined,
      );
      if (cleaned.length) acc[k] = cleaned;
    } else if (typeof v === "string") {
      const trimmed = v.trim();
      if (trimmed) acc[k] = trimmed;
    } else if (v !== undefined && v !== null && v !== "") {
      acc[k] = v;
    }
    return acc;
  }, {});
}

// Query-string form of the selection: mongoFilters travels as JSON, never as
// "[object Object]".
export function serializzaRicercaOrdini(ricerca) {
  if (!ricerca || ricerca.mongoFilters === undefined) return ricerca;
  const { mongoFilters, ...resto } = ricerca;
  const normalized = normalizzaMongoFilters(mongoFilters);
  return Object.keys(normalized).length
    ? { ...resto, mongoFilters: JSON.stringify(normalized) }
    : resto;
}

// Editable draft of the applied selection: departure groups expanded into
// `sped.Partenza_da IN` go back to their dropdown value.
export function bozzaDaRicerca(ricerca, groups) {
  return collapseDepartureGroup(ricerca || {}, groups);
}
